import { Model } from '../model';

export enum ChatMessageType {
    None = 0,
    Template = 1,
    User = 2,
    Reply = 3,
    Initialize = 4
}
